import richText from "utilities/richText"

export default function BenefitsChart({ blok }) {
  return (
    <section className="px-8 bg-grayPawprint py-12">
      <h2 className="uppercase text-center text-white pb-6 md:pb-12">{blok.title}</h2>
      <div className="max-w-4xl mx-auto">
        <div className="bg-green-sea px-6 md:px-12 py-6 prose-p:font-bold prose-p:text-black prose-p:text-s3 prose-p:lg:text-m1">
          {richText(blok.description)}
        </div>
        <div className="bg-white md:prose-ul:columns-2 md:prose-ul:gap-12 px-6 md:px-12 py-4 md:py-8 rounded-b-3xl prose-li:pb-1 lg:prose-li:pb-2">
          {richText(blok.benefits_list)}
        </div>
      </div>
    </section>
  )
}
